<!--/**-->
<!--* 自动生成 vue导入组件代码【模块名：红人基础数据记录】-->
<!--* 生成日期：2025/05/16 11:22:35-->
<!--* 生成路径: src/pages/kol_basic_record/ImportKolBasicRecord.vue-->
<!--* 生成人：管理员-->
<!--*/-->
<template>
  <div>
    <el-dialog v-bind='$attrs' v-on='$listeners' @open='onOpen' @close='onClose' :title='dialogTitle'
               fullscreen>

      <el-row :gutter='15'>
        <el-col :span='12'>
          <el-upload
            class='upload-demo'
            :on-change='handleChange'
            :on-success='importSuccess'
            :headers='uploadHeaders'
            :data='postData'
            name='file'
            :show-file-list='false'
            :file-list='file'
            :before-upload='beforeUpload'
            drag
            action='/admin_api/kol_basic_record/import'
            multiple>
            <i class='el-icon-upload'></i>
            <div class='el-upload__text'>将文件拖到此处，或<em>点击上传</em></div>
            <div class='el-upload__tip' slot='tip'></div>
          </el-upload>
        </el-col>
        <el-col :span='12'>
          <div>
            <export-btn :can-export='true' ref='refExportLink' type='primary' lintTitle='下载导入模板'
                        @export='downloadTpl'></export-btn>
          </div>
          <div>
            <tips :data='tipList'></tips>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span='24'>
          <div class='default-table' v-if='sheetData.length>0'>
            <el-divider>导入数据预览</el-divider>
            <el-tabs v-model='activeName' type='card'>
              <el-tab-pane :label='sheet.platform.name' :name='sheet.platform.code' v-for='(sheet,key) in sheetData'
                           :key='key'>
                <ImportTablePanel :ref='`TablePanel_${sheet.platform.code}`' height='500' :table-data='sheet.list'
                                  :columns='sheet.cols' v-if='sheet.cols.length>0' />
              </el-tab-pane>
            </el-tabs>
          </div>
          <div style='text-align: center;padding: 10px' v-if='showCommitBtn'>
            <el-button type='primary' :disabled='loadingCommit' :loading='loadingCommit' @click='onsubmit()'>提交
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import ExportBtn from '@/components/export/ExportBtn'
import { getToken } from '@/utils/auth'
import { batchSaveKolBasicRecord, exportKolBasicRecords, saveKolBasicRecord } from '@/api/kol_basic_record'
import ImportTablePanel from '@/pages/artist/base/modules/ImportTablePanel'
import { chunkArray } from '@/utils'

export default {
  name: 'ImportKolBasicRecord',
  components: { ImportTablePanel, ExportBtn },
  data() {
    return {
      dialogTitle: '导入',
      file: [],
      uploadLoading: false,
      uploadHeaders: { 'HYPERF-SESSION-ID': null },
      postData: {},
      maxSize: 20,//文件最大的 10 M
      tipList: [
        '第1步，下载模板',
        '第2步，按照模板规范填好数据后，根据提示上传文件',
        '注意：1）二次导入，将会追加数据 2）表格空行会过滤'
        // '第3步，预览导入的数据，确认无误后，点击“提交”按钮'
      ],
      offset: 0,
      height: 800,
      columns: [],
      importList: [],
      activeName: '',
      sheetData: [
        { list: [], cols: [], platform: { code: 'douyin', name: '抖音' } },
        { list: [], cols: [], platform: { code: 'xiaohongshu', name: '小红书' } }
      ],
      loadingCommit: false,
      len: 0,
      importedIndexList: [],
      showCommitBtn: true
    }
  },
  methods: {
    onOpen() {
      this.sheetData = [
        { list: [], cols: [], platform: { code: 'douyin', name: '抖音' } },
        { list: [], cols: [], platform: { code: 'xiaohongshu', name: '小红书' } }
      ]
      this.importList = []
      this.len = 0
      this.importedIndexList = []
      this.showCommitBtn = false
    },
    onClose() {

    },
    close() {
      this.$emit('update:visible', false)
    },

    async downloadTpl() {
      try {
        const name = `红人基础数据记录-导入模板`
        this.$notify.info(name)
        const queryParams = {
          is_tpl: true
        }
        const response = await exportKolBasicRecords(queryParams)
        this.$refs.refExportLink.exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },
    // ======================= 导入相关 =====================
    handleChange(file) {
      this.file = [file]
    },
    beforeUpload(file) {
      //身份凭据
      this.uploadHeaders['HYPERF-SESSION-ID'] = getToken()
      this.uploadLoading = true
      const isLt2M = file.size / 1024 / 1024 < this.maxSize
      if (!isLt2M) {
        this.$message.error(`导入文件大小不能超过 ${this.maxSize}MB!`)
        this.uploadLoading = false
      }
      return isLt2M
    },
    importSuccess(response) {
      this.showCommitBtn = true
      this.importList = []
      this.len = 0
      this.importedIndexList = []
      if (response.code === 200) {
        const data = response.data ? response.data : []
        this.sheetData = data.sheet_data || []
        this.showCommitBtn = true
        // console.log(JSON.stringify(sheetData))
        if (this.sheetData.length > 0)
          this.activeName = this.sheetData[0]?.platform?.code
      } else {
        this.$message.warning(response.message)
      }
    },
    batchStore(arr) {
      return new Promise((resolve) => {
        batchSaveKolBasicRecord(arr).then((resp) => {
          const data = resp.rows
          if (data && data.length > 0) {
            data.forEach((rowData) => {
              const pCodeIndex = this.sheetData.findIndex(value => value.platform?.code === rowData.platform_code)
              if (pCodeIndex !== -1) {
                const dataIndex = this.sheetData[pCodeIndex].list.findIndex(value => value.nickname === rowData.nickname)
                if (dataIndex !== -1) {
                  this.sheetData[pCodeIndex].list[dataIndex]['err_msg'] = rowData['err_msg'] || '未知原因'
                  this.sheetData[pCodeIndex].list[dataIndex]['row_class'] = rowData['row_class'] || 'default'
                }
              }
            })
          }
          //"SQLSTATE[23000]: Integrity constraint violation: 1062 Duplicate entry 'artzff9xwz08f0puxacoqfa7fd9b38e6-douyin' for key 'kol_basic_records_artist_id_platform_code_unique' (SQL: insert into `kol_basic_records` (`nickname`, `platform_code`, `artist_id`, `qty_fans`, `content`, `updated_at`, `created_at`) values (氧化菊, douyin, artzff9xwz08f0puxacoqfa7fd9b38e6, 11507000, {"nickname":"\u6c27\u5316\u83ca","total_fans":1150.7,"hp_link":"https:\/\/v.douyin.com\/Ndg5Gfg\/","star_map_link":"https:\/\/www.xingtu.cn\/ad\/creator\/author-homepage\/douyin-video\/68543290447212052612025-05-19 15:57:05market_track_id=FN6A7HAMPDME01NTC1W5&search_session_id=7504541191632191527&possessStarId&active_tab=content_performance&active_module=.content-video-list-panel&content_key_word=%E6%B0%A7%E5%8C%96%E8%8F%8A","MR":0.31,"FR":0.69,"AG_1":0.2,"AG_2":0.14,"AG_3":0.23,"AG_4":0.07,"AG_5":0.13,"GZ":0.39,"GMom":0.05,"GE":0.08,"GM":0.04,"GTY":0.22,"GB":0.08,"GTM":0.07,"GUS":0.06,"CFR":0.28,"CSR":0.2,"ratio_iphone":0.28,"CR":0.2572,"ER":0.0442,"AP":3834000,"MAU":175470,"CPM":136,"CPE":2.9,"other_auth":null,"ec_auth":null,"h_link":null,"d_win":null,"hg_page":null,"lbw":null,"direct_ad":null,"platform_code":"douyin","platform_name":"\u6296\u97f3","artist_id":"artzff9xwz08f0puxacoqfa7fd9b38e6","qty_fans":11507000}, 2025-05-19 15:57:05, ?))"
          resolve({ success: resp.success, failed: resp.failed })
        })
      })
    },
    async onsubmit() {
      this.len = 0
      this.importedIndexList = []
      this.loadingCommit = true
      const batchRows = []
      this.sheetData.forEach((sheet) => {
        // 批量保存数据
        sheet.list.forEach((row) => {
          row.platform_code = sheet.platform.code
          row.platform_name = sheet.platform.name

          batchRows.push(row)
        })
      })

      const batchArr = chunkArray(batchRows, 10)
      const proms = []
      batchArr.forEach((arr) => {
        proms.push(this.batchStore(arr))
      })

      await Promise.all(proms)

      this.loadingCommit = false
      this.showCommitBtn = false
      // if (this.importList.length > 0) {
      //   this.saveRow(0)
      // }


    },
    async saveRow(index) {
      // console.log('index', index)
      // 有效表格数据索引
      if (index < this.importList.length) {
        if (this.importedIndexList.indexOf(index) === -1) {
          this.importedIndexList.push(index)
          const row = this.importList[index]
          await saveKolBasicRecord(row)

          setTimeout(() => {
            index++
            this.saveRow(index)
          }, 100)
        }
      } else {
        setTimeout(() => {
          this.loadingCommit = false
          this.showCommitBtn = false
        }, 500)
        this.$emit('imported')
      }
    },
    // eslint-disable-next-line no-unused-vars
    rowClassName({ row, rowIndex }) {
      if (this.importedIndexList.indexOf(rowIndex) === -1) {
        return 'wait-upload'
      } else {
        return 'uploaded'
      }
    }
  }
}
</script>


<style scoped>
.sheet-title {
  font-size: 22px;
  font-weight: bold;
  color: var(--primary);
}

</style>
